import { render, staticRenderFns } from "./leftMenu.vue?vue&type=template&id=312e970d&scoped=true"
import script from "./leftMenu.vue?vue&type=script&lang=js"
export * from "./leftMenu.vue?vue&type=script&lang=js"
import style0 from "./leftMenu.vue?vue&type=style&index=0&id=312e970d&prod&lang=scss&scoped=true"
import style1 from "./leftMenu.vue?vue&type=style&index=1&id=312e970d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312e970d",
  null
  
)

export default component.exports